import React from "react";
import { sNotification } from "../constants/strings";
import { Stack } from "@mui/material";
import { GenericInput } from "../components/input/GenericInput";
import { FormWrapper } from "../components/styled/StyledComponents";
import { FormButton } from "../components/buttons/FormButton";
import { GenericSelect } from "../components/select/GenericSelect";
import { NOTIFICATIONS_API } from "../constants/api";
import useForm from "../hooks/useForm";
import { useFirebase } from "../hooks/firebase/useFirebase";
import { Button } from "antd";
import { serverTimestamp } from "firebase/firestore";

export const NotificationForm = () => {
  const { form, onChange, updateFormValues, clearForm } = useForm();
  const { loading, addData: addNotification } = useFirebase();

  function createNotification() {
    form.timestamp = serverTimestamp();
    addNotification(NOTIFICATIONS_API, form, clearForm());
  }

  const onSubmit = (e) => {
    e.preventDefault();
    createNotification();
  };

  return (
    <form onSubmit={onSubmit}>
      <FormWrapper>
        <Stack spacing={3}>
          {/* Name */}
          <GenericInput
            label="Title"
            required
            value={form?.title}
            name="title"
            onChange={onChange}
          />
          <GenericInput
            label="Message"
            rows={2}
            required
            value={form?.body}
            name="body"
            onChange={onChange}
          />
          <GenericSelect
            label="Send To"
            // mode="tags"
            value={form?.topic}
            required
            onChange={(value) => {
              updateFormValues({ topic: value });
            }}
            options={[
              {
                label: "All Users",
                value: "all",
              },
            ]}
            helperText="Type email address to send notifications to specific users"
          />

          {/* Submit */}
          <FormButton loading={loading}>{`Send ${sNotification}`}</FormButton>
          {/* Clear all */}
          <Button onClick={clearForm}>Clear All</Button>
        </Stack>
      </FormWrapper>
    </form>
  );
};
